import {createQueryString} from "../Api";

const INITIAL_STATE = {
  all: [],
  converters: [],
  modalConverter: null,
  current: null,
}

export default {
	namespaced: true,
	state: {
		...INITIAL_STATE
	},
	getters: {
		find: (state) => (id) => state.find(el => el.id === id),
	},
	mutations: {
		setCurrent: (state, {item}) => {
			state.current = item;
		},
		setModalConverter: (state, modalConverter) => {
			state.modalConverter = modalConverter;
		},
		add: (state, {item, prepend = false}) => {
			if (prepend) {
				state.all.unshift(item);
			} else {
				state.all.push(item);
			}
		},
		remove: (state, {id}) => {
			let idx = state.all.findIndex(el => el.id === id);
			state.all.splice(idx, 1);
		},
		addConverter: (state, {item, prepend = false}) => {
			if (prepend) {
				state.converters.unshift(item);
			} else {
				state.converters.push(item);
			}
		},
		clearConverters: (state) => {
			state.converters = [];
		}
		
	},
	actions: {
		add: ({dispatch, rootGetters, commit}, {name = 'default', inventory_own_products = [], inventory_converters = [], margin_value = 0, view_mode = 1, currency_id = 2, apply_margin_to_own_positions = false, margin_type = 3} = {}) => {
			let headers = {
				'Content-Type': 'application/json',
			};
			Object.assign(headers, rootGetters['Api/getAuthHeader']);
			
			return dispatch('Api/apiRequest', {
				actionPath: '/api/inventory/add.json',
				method: 'put',
				headers: headers,
				data: {
					inventory_own_products,
					inventory_converters,
					name,
					margin_value,
					view_mode,
					currency_id,
					apply_margin_to_own_positions,
					margin_type
				},
			}, {root: true}).then(result => {
				return Promise.resolve(result);
			})
		},
		all: ({dispatch, rootGetters, commit}) => {
			let headers = {
			};
			Object.assign(headers, rootGetters['Api/getAuthHeader']);
			
			return dispatch('Api/apiRequest', {
				actionPath: '/api/inventory/all.json',
				method: 'get',
				headers: headers,
				
			}, {root: true}).then(result => {
				
				
				return Promise.resolve(result);
			})
		},
		get: ({dispatch, rootGetters, commit}, {id}) => {
			let headers = {
			};
			
			Object.assign(headers, rootGetters['Api/getAuthHeader']);
			
			return dispatch('Api/apiRequest', {
				actionPath: ['/api/inventory/get/', id, '.json'].join(''),
				method: 'get',
				headers: headers,
			}, {root: true}).then(result => {
				
				commit('setCurrent', {item: result});
				
				return Promise.resolve(result);
			})
		},
		sendToBv: ({dispatch, rootGetters, commit}, {id}) => {
			let headers = {
				'Content-Type': 'application/json',
			};
			
			Object.assign(headers, rootGetters['Api/getAuthHeader']);
			
			return dispatch('Api/apiRequest', {
				actionPath: ['/api/inventory/sendToBv/', id, '.json'].join(''),
				method: 'post',
				headers: headers,
			}, {root: true}).then(result => {
				return Promise.resolve(result);
			})
		},
		getConverters: ({dispatch, rootGetters, commit}, {filter = {}, limit = {}, language = undefined} = {}) => {
			let headers = {
				'Content-Type': 'application/json',
			};
			Object.assign(headers, rootGetters['Api/getAuthHeader']);
			
			let actionPath = '/api/converters/all.json';
			let query = createQueryString({filter, limit, language})
			if (query) {
				actionPath = [actionPath, query].join('?');
			}
			
			return dispatch('Api/apiRequest', {
				actionPath: actionPath,
				method: 'get',
				headers: headers,
			}, {root: true}).then(result => {
				
				commit('clearConverters');
				
				result.forEach(item => commit('addConverter', {item}));
				
				return Promise.resolve(result);
			})
		},
	}
}
